<template>
	<view class="box">
		<!-- <view class="zhezhao"></view> -->
		<view class="head">
			<u-search
				placeholder="请输入关键词"
				:showAction="false"
				bgColor="#F8F9FB"
				placeholderColor="#999999"
				searchIconSize="28"
				height="36"
				v-model="keyword" />
			<view class="head-cate">
				<u-tabs :list="list" lineColor="#004096" lineWidth="24" lineHeight="3"></u-tabs>
			</view>
			<view class="head-search">
				<view class="head-search-item">
					<text class="fontact">排序</text>
					<u-icon name="arrow-up" color="#222222" size="14"></u-icon>
					<!-- <u-icon name="arrow-down" color="#777777" size="14"></u-icon> -->
				</view>
				<view class="head-search-item">
					<text>适用品牌</text>
					<u-icon name="arrow-down" color="#777777" size="14"></u-icon>
				</view>
				<view class="head-search-item">
					<text>系列</text>
					<u-icon name="arrow-down" color="#777777" size="14"></u-icon>
				</view>
			</view>
			<!-- <view class="data">
				<view class="data-cate">
					<view class="data-cate-item active">自营品牌</view>
					<view class="data-cate-item">雷沃</view>
					<view class="data-cate-item">洋马</view>
					<view class="data-cate-item">星光</view>
					<view class="data-cate-item">中联</view>
					<view class="data-cate-item">久保田</view>
				</view>
				<view class="data-list">
					<view class="data-list-item active">
						<text>综合排序</text>
						<image src="/static/icon/ic_sele1te@2x.png" mode="widthFix"></image>
					</view>
					<view class="data-list-item">
						<text>销量由高到低</text>
					</view>
					<view class="data-list-item">
						<text>价格由低到高</text>
					</view>
				</view>
			</view> -->
		</view>
		<view class="list">
			<view class="list-item" v-for="(item, index) in 10" :key="index">
				<view class="list-item-image">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<view class="list-item-info">
					<view class="list-item-info-title">中联艾禾宽齿 适用雷沃/中联/久保田</view>
					<view class="price">¥398.00</view>
					<view class="list-item-info-label">
						<text>供货价¥100.00</text>
						<text>本店销量：219</text>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				keyword: '',
				list: [{
					name: '全部',
				}, {
					name: '支重轮',
				}, {
					name: '托轮'
				}, {
					name: '平衡轮'
				}, {
					name: '导轨'
				}, {
					name: '导向轮'
				}]
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.zhezhao {
			width: 100vw;
			height: 100vh;
			background: rgba(0,0,0,0.5);
			position: fixed;
			top: 0;
			left: 0;
			z-index: 2;
		}
		.head {
			width: 100%;
			height: 280rpx;
			padding: 20rpx 0 0 0;
			box-sizing: border-box;
			background: #FFFFFF;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 99;
			.head-cate {
				width: 100%;
				height: 100rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				align-items: flex-end;
				border-bottom: 1rpx solid #E5E5E5;
			}
			.head-search {
				width: 100%;
				height: 86rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-around;
				.head-search-item {
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					position: relative;
					.fontact {
						color: #222222 !important;
						font-weight: 500 !important;
					}
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #777777;
						margin-right: 8rpx;
					}
				}
			}
			.data {
				width: 100%;
				padding: 0 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 0rpx 0rpx 24rpx 24rpx;
				.data-cate {
					width: 100%;
					padding: 30rpx 0 10rpx 0;
					box-sizing: border-box;
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					justify-content: space-between;
					.active {
						background: rgba(0,64,150,0.1) !important;
						font-weight: 500 !important;
						color: #004096 !important;
					}
					.data-cate-item {
						width: 216rpx;
						height: 72rpx;
						line-height: 72rpx;
						text-align: center;
						background: #F7F7F7;
						border-radius: 8rpx;
						font-weight: 400;
						font-size: 28rpx;
						color: #333333;
						margin-bottom: 20rpx;
					}
				}
				.data-list {
					width: 100%;
					display: flex;
					flex-direction: column;
					.active {
						text {
							color: #004096 !important;
						}
					}
					.data-list-item {
						width: 100%;
						height: 98rpx;
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-bottom: 1rpx solid #EEEEEE;
						text {
							font-weight: 400;
							font-size: 28rpx;
							color: #222222;
						}
						image {
							width: 24rpx;
							height: 18rpx;
						}
					}
				}
			}
		}
		.list {
			width: 100%;
			margin-top: 18rpx;
			padding: 0 30rpx;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			background-color: #ffffff;
			.list-item {
				width: 100%;
				padding: 28rpx 0;
				box-sizing: border-box;
				border-bottom: 1rpx solid #E5E5E5;
				display: flex;
				align-items: center;
				.list-item-image {
					flex-shrink: 0;
					margin-right: 24rpx;
					width: 144rpx;
					height: 144rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 8rpx;
					overflow: hidden;
					border: 1rpx solid #E5E5E5;
					image {
						width: 100%;
					}
				}
				.list-item-info {
					flex: 1;
					display: flex;
					flex-direction: column;
					.list-item-info-title {
						font-weight: 400;
						font-size: 30rpx;
						color: #222222;
					}
					.price {
						font-weight: 600;
						font-size: 30rpx;
						color: #E4001D;
						margin-top: 16rpx;
						margin-bottom: 10rpx;
					}
					.list-item-info-label {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							font-weight: 400;
							font-size: 24rpx;
							color: #666666;
						}
					}
				}
			}
		}
	}
</style>